export default __webpack_public_path__ + "static/media/pdr.d3c64782.png";